import { randint } from './maths';

export const choice = (x: string): string => x[randint(0, x.length)]

/** return all characters of a string except the last one */
export const init = (x: string) => x.slice(0, x.length - 1)
